import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { NETWORK } from '@arianee/arianeejs/dist/src';
import { HttpClient } from '@angular/common/http';
import { from, Observable } from 'rxjs';
import { IdentityBase } from '@arianee/arianeejs/dist/src/models';
import { ArianeeService } from '../arianee-service/arianee.service';
import { mergeMap, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ArianeeApiService {
  urlIdentity: string;
  walletApiUrl: string;

  constructor (
    private http: HttpClient,
    private arianeeService:ArianeeService
  ) {
    this.arianeeService
      .$walletInitialize
      .subscribe((network: NETWORK) => {
        this.urlIdentity = `${environment.arianeeApi.url}/identity/${network}/identities`;
      });

    this.walletApiUrl = environment.walletApi.url;
  }

  /**
   * Get all Arianee identities
    */
  getIdentities (): Observable<IdentityBase[]> {
    return this.http.get<IdentityBase[]>(this.urlIdentity);
  }

  /**
   * Ask for adding a New Brand to Arianee
   * @param brand: Brand name
   * @param email: current user email
   */
  askForNewBrand (brand: string): Observable<any> {
    return from(this.arianeeService.getWalletInstance(NETWORK.mainnet)).pipe(
      take(1),
      mergeMap(wallet => {
        const address = wallet.address;
        return this.http.post<any>(`${this.walletApiUrl}/brand/subscribe`,
          { address, brand });
      })
    );
  }
}
